import { useQuery } from "@tanstack/react-query";
import $api from "../../api/$api";
import { TFetchTranscriptData } from "./type";

export const fetchTranscriptData = async (data: TFetchTranscriptData) => {
  const { transcriptDataURL, teamID, accessToken } = data;

  if (!transcriptDataURL || !teamID || !accessToken) {
    throw new Error("Missing required parameters");
  }

  const response = await $api.get("/state/artifact", {
    params: {
      artifactID: transcriptDataURL,
      groupID: teamID,
      redirectOutput: true
    },
    token: accessToken
  });

  return response;
};

export const useFetchTranscriptData = (data: TFetchTranscriptData) => {
  return useQuery({
    staleTime: 1000 * 60 * 2,
    queryKey: ["fetchTranscriptData", data.transcriptDataURL, data.teamID],
    queryFn: () => fetchTranscriptData(data),
    enabled: !!data.transcriptDataURL && !!data.teamID && !!data.accessToken,
    retry: 1,
    retryDelay: 3000,
  });
};
